import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import styles from './login.module.css';
import api from '../../utils/api';
import Toastify from '../../utils/Toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Login = () => {
    const { appearences, loading } = useSelector((state) => state.appearences)
    const location = useLocation()
    const from = location.state
    const [passwordVisible, setPasswordVisible] = useState(false);
    const navigate = useNavigate()
    const [isLoding, setIsloading] = useState(false)
    const [bgImage, setBgImage] = useState('/assets/login.png');

    useEffect(() => {
        const reason = sessionStorage.getItem("logoutReason");
        if (reason === "passwordChanged") {
            Toastify.warning("Logged Out", "You have been logged out because your password was changed on another device. Please log in again.");
            sessionStorage.removeItem("logoutReason");
        }
    }, []);

    useEffect(() => {
        if (appearences?.loginBanner?.image) {
            const img = new Image();
            img.src = appearences.loginBanner.image;
            img.onload = () => setBgImage(appearences.loginBanner.image);
            img.onerror = () => setBgImage('/assets/login.png');
        } else {
            setBgImage('/assets/login.png');
        }
    }, [appearences?.loginBanner?.image]);

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    // Formik form handling and validation
    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email('Invalid email address')
                .required('Email is required'),
            password: Yup.string()
                .required('Password is required')
        }),
        onSubmit: async (values) => {
            try {
                setIsloading(true)
                const response = await api.login(values);
                if (response.data) {
                    Toastify.success("Logged in")

                    localStorage.setItem("token", response.data?.data?.token);
                    if(from == "popup"){
                        navigate(-1)
                    }else{
                        navigate('/')
                    }
                }
            } catch (err) {
                console.log('Login Error', err);
                Toastify.error(err?.response?.data?.message)
            } finally {
                setIsloading(false)
            }
        }
    });


    console.log(appearences?.loginBanner?.image);


    return (
        <>
            <div className={styles.loginContainer}
                style={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    backgroundAttachment: "fixed",
                    backgroundSize: 'cover',
                    height: '100vh',
                }}>
                <div className={styles.loginInner}>

                    <div className={styles.loginCol1} onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                        <img src='/assets/logo.png' alt="Logo" />
                    </div>
                    <div className={styles.loginCol2}>
                        <div className={styles.loginCard}>
                            <h3>Login</h3>
                            <div className={styles.loginContent}>
                                <form className={styles.loginForm} onSubmit={formik.handleSubmit}>
                                    <div className={styles.loginInputGroup}>
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Add Email Address"
                                            value={formik.values.email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            required
                                        />
                                        {formik.touched.email && formik.errors.email ? (
                                            <div className={styles.error}>{formik.errors.email}</div>
                                        ) : null}
                                    </div>
                                    <div className={styles.loginInputGroup}>
                                        <label>Password</label>
                                        <div className={styles.passwordContainer}>
                                            <input
                                                type={passwordVisible ? 'text' : 'password'}
                                                name="password"
                                                placeholder="Enter Password"
                                                value={formik.values.password}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                className={styles.passwordInput}
                                                required
                                            />
                                            <FontAwesomeIcon
                                                icon={passwordVisible ? faEyeSlash : faEye}
                                                className={styles.passwordIcon}
                                                onClick={togglePasswordVisibility}
                                            />
                                        </div>
                                        <span className={styles.forgotPassword} onClick={() => navigate('/forgotPassword')} style={{ cursor: 'pointer' }}>Forgot password?</span>
                                    </div>
                                    <button type="submit" className={styles.loginButton} disabled={isLoding} >
                                        {isLoding ? 'Please wait...' : 'Log In'}
                                    </button>
                                </form>
                                <div className={styles.loginAccLinks}>
                                    <div className={styles.loginSeparator} >
                                        <div className={styles.separator}></div>
                                        <p>New to ElectroWiz?</p>
                                        <div className={styles.separator}></div>
                                    </div>
                                    <button className={styles.loginCreateAccBtn} onClick={() => navigate('/register')}>
                                        Create an account
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default Login;
